export default "__VITE_PUBLIC_ASSET__60e4b7d3__"